import React, { useEffect, useState, useCallback, useRef } from "react";
import { Pie, Bar } from "react-chartjs-2";
import axios from "axios";
import { URL } from "../../constants/insurance/constant.js";
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    BarElement
} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);

    const DailyChart = ({ setShowBarTable, setShowTable, showTable, setShowTable1, showTable1, redirectToHistory}) => {
    const [hourlyData, setHourlyData] = useState([]);
    const [barChartData, setBarChartData] = useState(null);
    const [pieChartData, setPieChartData] = useState(null);
    const [clickedDatasetLabel, setClickedDatasetLabel] = useState('');
    const [totalESales, setTotalESales] = useState(0);
    const [orderCreated, setorderCreated] = useState(0);
    const [selectedData, setSelectedData] = useState([]);
    const [allData, setAllData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const tableRef = useRef(null);

    const handleDownloadCSV = () => {
        if (!selectedData.length) return;
        const headers = ['Date', 'Insurer ID', 'Insurer Name', 'ESales ID', 'Request ID'];
        const csvContent = [
            headers.join(','),
            ...selectedData.map(item =>
                [item.Date, item.insurer_id, item.insurer_name, item.esale_id, item.request_id].join(',')
            )
        ].join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'esales_data.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };

    const handleBarClick = (event, elements) => {
        if (elements.length > 0) {
            const clickedIndex = elements[0].index;
            const clickedLabel = barChartData.labels[clickedIndex];
            const datasetIndex = elements[0].datasetIndex;
            const datasetLabel = barChartData.datasets[datasetIndex].label;
            let filteredData;
            switch (datasetLabel) {
                case 'Orders Created':
                    filteredData = allData.filter(item => new Date(item.Date).getHours() - 5 === parseInt(clickedLabel.split(':')[0]) && item.order_id !== 0);
                    break;
                case 'Order Not Created':
                    filteredData = allData.filter(item => new Date(item.Date).getHours() - 5 === parseInt(clickedLabel.split(':')[0]) && item.order_id === 0);
                    break;
                case 'QC Approved':
                    filteredData = allData.filter(item => new Date(item.Date).getHours() - 5 === parseInt(clickedLabel.split(':')[0]) && item.status_id === 48 && item.order_id !== 0);
                    break;
                case 'In Process Cases':
                    filteredData = allData.filter(item => new Date(item.Date).getHours() - 5 === parseInt(clickedLabel.split(':')[0]) && item.status_id !== 48 && item.order_id !== 0);
                    break;
                default:
                    filteredData = allData.filter(item => new Date(item.Date).getHours() - 5 === parseInt(clickedLabel.split(':')[0]));
            }
            if (filteredData.length > 0) {
                setSelectedData(filteredData);
                setClickedDatasetLabel(datasetLabel);
                setShowTable(prevShowTable => {
                    setShowBarTable(false);
                    setShowTable1(false);
                    setCurrentPage(1);
                    const newShowTable = !prevShowTable;
                    if (newShowTable && tableRef.current) {
                        setTimeout(() => {
                            tableRef.current?.scrollIntoView({ behavior: 'smooth' });
                        }, 50);
                    }
                    return newShowTable;
                });
            }
        }
    };

    const handlePieClick = (event, elements) => {
        if (elements.length > 0) {
            const clickedIndex = elements[0].index;
            const clickedLabel = pieChartData.labels[clickedIndex];
            let filterCondition;
            switch (clickedLabel) {
                case "Orders Created":
                    filterCondition = item => item.order_id !== 0;
                    break;
                case "Orders Not Created":
                    filterCondition = item => item.order_id === 0;
                    break;
                case "QC Approved":
                    filterCondition = item => item.status_id === 48 && item.order_id !== 0;
                    break;
                case "In Process Cases":
                    filterCondition = item => item.status_id !== 48 && item.order_id !== 0;
                    break;
                default:
                    filterCondition = () => true;
            }

            const filteredData = allData.filter(filterCondition);
            setSelectedData(filteredData);
            setClickedDatasetLabel(clickedLabel);
            setShowTable(prevShowTable => {
                setShowBarTable(false);
                setShowTable1(false);
                setCurrentPage(1);
                const newShowTable = !prevShowTable;
                if (newShowTable && tableRef.current) {
                    setTimeout(() => {
                        tableRef.current?.scrollIntoView({ behavior: 'smooth' });
                    }, 50);
                }
                return newShowTable;
            });
        }
    };

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    let erIds;
    try {
        const storedData = localStorage.getItem("erIDs");
        erIds = storedData ? JSON.parse(storedData) : [];
    } catch {
        erIds = [];
    }
    const fetchData = async () => {
        const hourlyCounts = Array(24).fill(0);
        try {
            setLoading(true);
            setError(null);
            const response = await axios.post(
                `${URL.fuser_url}api/v1/request/generic/getTodaysESalesCasesConversion/raw`,
                { erIds: erIds },
                { headers: { "Content-Type": "application/json" } }
            );

            if (!response.data || !response.data.data) {
                throw new Error('Invalid data format received from API');
            }
            const categorizedData = processData(response.data.data);
            response.data.data.forEach(item => {
                const hour = new Date(item.Date).getHours() - 5;
                hourlyCounts[hour] += 1;
            });
            setHourlyData(hourlyCounts);
            setAllData(response.data.data);
            setTotalESales(response.data.data.length);
            setPieChartData(formatPieChartData(categorizedData));
            const barChartData = formatBarChartData(response.data.data);
            setBarChartData(barChartData);
        } catch (err) {
            setError('Failed to load chart data. Please try again later.');
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);
    const processData = (data) => {
        const grouped = {
            created: 0,
            not_created: 0,
            qc_approved: 0,
            in_process: 0,
            request_id: 0
        };
        data.forEach(item => {
            if (item.order_id !== 0) {
                grouped.request_id = item.request_id;
                grouped.created += 1;
                if (item.status_id === 48) {
                    grouped.qc_approved += 1;
                } else {
                    grouped.in_process += 1;
                }
            } else {
                grouped.not_created += 1;
            }
        });
        return grouped;
    };

    //pie chart
    const formatPieChartData = (data) => {
        setorderCreated(data.created);
        return {
            labels: ["Orders Created", "Orders Not Created", "QC Approved", "In Process Cases"],
            datasets: [
                {
                    data: [data.created, data.not_created, data.qc_approved, data.in_process],
                    backgroundColor: ["#6AC48E", "#474A8A", "#888888", "#F68B5F"],
                },
            ],
        };
    };

    //bar chart
    const formatBarChartData = (data) => {
        const labels = Array.from({ length: 24 }, (_, i) => `${i}:00`);
        const esalesCount = Array(24).fill(0);
        const ordersCreated = Array(24).fill(0);
        const ordersNotCreated = Array(24).fill(0);
        const qcApproved = Array(24).fill(0);
        const inProcessCases = Array(24).fill(0);
        data.forEach(item => {
            const hour = new Date(item.Date).getHours() - 5;
            esalesCount[hour] += 1;
            if (item.order_id !== 0) {
                ordersCreated[hour] += 1;
                if (item.status_id === 48) {
                    qcApproved[hour] += 1;
                } else {
                    inProcessCases[hour] += 1;
                }
            } else {
                ordersNotCreated[hour] += 1;
            }   
        });
        return {
            labels,
            datasets: [
                {
                    label: "ESales Count",
                    data: esalesCount,
                    backgroundColor: "#46A6EA",
                },
                {
                    label: "Orders Created",
                    data: ordersCreated,
                    backgroundColor: "#6AC48E",
                },
                {
                    label: "Orders Not Created",
                    data: ordersNotCreated,
                    backgroundColor: "#474A8A",
                },
                {
                    label: "QC Approved",
                    data: qcApproved,
                    backgroundColor: "#888888",
                },
                {
                    label: "In Process Cases",
                    data: inProcessCases,
                    backgroundColor: "#F68B5F",
                },
            ],
        };
    };
    useEffect(() => {
        if (showTable && tableRef.current) {
            tableRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }, [showTable]);

    return (
        <div style={{
            width: "100%",
            maxWidth: "100%",
            margin: "auto",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            textAlign: "left",
            fontFamily: 'Lexend Deca',
        }}>
            <h5 style={{ marginBottom: "10px", fontWeight: "bold",paddingLeft:'20px' }}>
                Today's Esales Conversion : {orderCreated}
            </h5>
            <div style={{ width: "100%", height: "400px" }}>
                {loading || !pieChartData ? (
                    <p>Loading chart...</p>
                ) : error ? (
                    <p style={{ color: 'red' }}>{error}</p>
                ) : totalESales > 0 ? (
                    <Pie
                        data={pieChartData}
                        options={{
                            plugins: {
                                legend: {
                                    position: "bottom",
                                    labels: {
                                        font: { size: 14 }
                                    },
                                    onHover: (event) => {
                                        event.native.target.style.cursor = "pointer";
                                    },
                                    plugins: {
                                        legend: {
                                            position: "bottom", labels: {
                                                font: {
                                                    weight: 'bold'
                                                }
                                            }
                                        },
                                        title: { display: true }
                                    },
                                },
                            },
                            onHover: (event, chartElement) => {
                                if (chartElement.length) {
                                    event.native.target.style.cursor = "pointer";
                                } else {
                                    event.native.target.style.cursor = "default";
                                }
                            },
                            maintainAspectRatio: false,
                            responsive: true,
                            onClick: handlePieClick
                        }} />
                ) : null}
            </div>
            <div style={{ height: '2px', backgroundColor: '#888888', margin: '20px 0', marginBottom: "40px" }}></div>

            <h5 style={{paddingLeft:'20px'}}><b>Today's Hourly ESales Conversion </b></h5>
            <div style={{ width: "100%", height: "400px" }}>
                {loading || !pieChartData ? (
                    <p>Loading bar chart...</p>
                ) : error ? (
                    <p style={{ color: 'red' }}> {error} </p>
                ) : (
                    <Bar
                        data={barChartData}
                        options={{
                            plugins: {
                                legend: {
                                    position: "bottom"
                                },
                            },
                            plugins: {
                                legend: {
                                    position: "bottom", labels: {
                                        font: {
                                            weight: 'bold'
                                        },
                                    }, onHover: (event) => {
                                        event.native.target.style.cursor = "pointer";
                                    }
                                },
                                title: { display: true }
                            },
                            scales: {
                                x: {
                                    grid: { display: false }, title: {
                                        display: true,
                                        text: "Time",
                                        font: {
                                            size: 14,
                                            weight: "bold"
                                        }
                                    },
                                    ticks: {
                                        font: {
                                            weight: "bold"
                                        }
                                    }
                                },
                                y: {
                                    beginAtZero: true, title: {
                                        display: true,
                                        text: "Conversion Count",
                                        font: {
                                            size: 14,
                                            weight: "bold"
                                        }
                                    },
                                    ticks: {
                                        font: {
                                            weight: "bold"
                                        }
                                    }
                                },
                            },
                            onHover: (event, chartElement) => {
                                if (chartElement.length) {
                                    event.native.target.style.cursor = "pointer";
                                } else {
                                    event.native.target.style.cursor = "default";
                                }
                            },
                            maintainAspectRatio: false,
                            responsive: true,
                            onClick: handleBarClick
                        }}
                    />
                )}
            </div>
            <div style={{ height: '2px', backgroundColor: '#888888', margin: '20px 0' }}></div>

            {/*table data*/}
            {showTable && (
                <div ref={tableRef} style={{
                    margin: '20px 0',
                    position: 'relative',
                    fontFamily: 'Lexend Deca',
                    width: '100%'
                }}>
                    <h5>
                        <b>
                            {clickedDatasetLabel ? `${clickedDatasetLabel}: ${selectedData.length}` : `Count: ${selectedData.length}`}
                        </b>
                    </h5>
                    <table style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        fontSize: '0.8em',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        fontFamily: 'Lexend Deca'
                    }}>
                        <thead>
                            <tr style={{ backgroundColor: '#46A6EA', textAlign: "center" }}>
                                <th style={{ padding: '8px', border: '1px solid #ddd', color: '#000', borderRadius: '8px 0 0 0' }}>Date</th>
                                <th style={{ padding: '8px', border: '1px solid #ddd', color: '#000' }}>Insurer ID</th>
                                <th style={{ padding: '8px', border: '1px solid #ddd', color: '#000' }}>Insurer Name</th>
                                <th style={{ padding: '8px', border: '1px solid #ddd', color: '#000' }}>ESales ID</th>
                                <th style={{ padding: '8px', border: '1px solid #ddd', color: '#000', borderRadius: '0 8px 0 0' }}>Request ID</th>
                            </tr>
                        </thead>
                        <tbody>
                            {selectedData
                                .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
                                .map((item, index) => (
                                    <tr key={index} style={{ backgroundColor: 'white', color: '#000', textAlign: 'center' }}>
                                        <td style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '0 0 0 8px' }}>
                                            {new Date(item.Date).toLocaleDateString()}
                                        </td>
                                        <td style={{ padding: '8px', border: '1px solid #ddd' }}>{item.insurer_id}</td>
                                        <td style={{ padding: '8px', border: '1px solid #ddd' }}>{item.insurer_name}</td>
                                        <td style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '0 0 8px 0' }}>{item.esale_id}</td>
                                        <td style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '0 0 0 8px' }}>
                                        {item.request_id ? (
                                        <span style={{ color: 'blue', cursor: 'pointer' }} onClick={(e) => redirectToHistory(e, item.request_id)}>
                                        {item.request_id}</span>) : ( "-" )}
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                    <div style={{
                        position: 'absolute',
                        right: '0',
                        padding: '5px 10px',
                        fontWeight: 'bold',
                        fontSize: '0.9em',
                        color: '#000',
                    }}>
                        Showing {(currentPage - 1) * itemsPerPage + 1} - {Math.min(currentPage * itemsPerPage, selectedData.length)} of {selectedData.length}
                    </div>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        margin: '10px 0',
                        gap: '10px'
                    }}>
                        <button
                            onClick={handleDownloadCSV}
                            style={{
                                padding: '0px 10px',
                                backgroundColor: '#46A6EA',
                                color: '#fff',
                                border: 'none',
                                fontFamily: 'Lexend Deca',
                                borderRadius: '3px',
                                cursor: 'pointer'
                            }}  >
                            Export ⬇
                        </button>
                        <button
                            onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                            disabled={currentPage === 1}
                            style={{
                                padding: '0px 10px',
                                backgroundColor: currentPage === 1 ? '#ccc' : '#46A6EA',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '3px',
                                fontFamily: 'Lexend Deca',
                                cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                            }}   >
                            Previous
                        </button>
                        <button
                            onClick={() => setCurrentPage(prev => prev + 1)}
                            disabled={currentPage * itemsPerPage >= selectedData.length}
                            style={{
                                padding: '0px 25px',
                                backgroundColor: currentPage * itemsPerPage >= selectedData.length ? '#ccc' : '#46A6EA',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '3px',
                                fontFamily: 'Lexend Deca',
                                cursor: currentPage * itemsPerPage >= selectedData.length ? 'not-allowed' : 'pointer'
                            }}> Next
                        </button>
                    </div>
                    <div style={{ height: '2px', backgroundColor: '#888888', margin: '20px 0' }}></div>
                </div>
            )}
        </div>
    );
};
export default DailyChart;
